import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Quemás perfiles caros por errores de cálculo', 'No sabés cuánto cobrar con tanta inflación', 'Llegás a la obra y la ventana no entra', 'Mandás presupuestos y el cliente desaparece', 'Trabajás mucho y al final del mes no te queda nada', 'El mercado premium (A30 con DVH) existe pero no podés entrar'];
export function PainPointsSection() {
  return <section className="py-10 bg-white" data-id="element-192">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-193">
        <div className="text-center mb-8" data-id="element-194">
          <h2 className="text-3xl md:text-4xl font-black text-matte mb-2" data-id="element-195">
            ¿Te pasa esto?
          </h2>
          <div className="w-16 h-1 bg-red-600 mx-auto" data-id="element-196"></div>
        </div>

        <div className="space-y-3 mb-8" data-id="element-197">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.06
        }} className="flex items-center bg-red-50 border border-red-100 px-5 py-3" data-id="element-198">
              <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0" data-id="element-199" />
              <p className="text-base font-medium text-matte" data-id="element-200">{point}</p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-201">
          <p className="text-lg text-gray-600 mb-2 font-medium" data-id="element-202">
            Todos esos problemas tienen una sola causa:
          </p>
          <h3 className="text-2xl md:text-3xl font-black text-steel mb-6" data-id="element-203">
            No tenés el sistema correcto.
          </h3>
          <div className="bg-matte text-white p-5 border-l-4 border-gold" data-id="element-204">
            <p className="text-base italic text-gray-300" data-id="element-205">
              "Un carpintero que trabaja sin sistema regala horas, quema
              materiales y cobra de menos. Con el sistema correcto, los mismos
              trabajos generan el doble."
            </p>
          </div>
        </div>
      </div>
    </section>;
}